<template>
  <sa-page-layout :btnNewVisible="true" :btnRefreshVisible="true" @refresh="onRefresh" :pathResource="pathResource" :linkedit="linkedit" :showModalLoading="showModalLoading">
    <template slot="table-filter">
      <b-form @submit.prevent="onSubmit">
        <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
          <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
            <label class="sa-label-data">Nome</label>
            <b-form-input v-model="filtro.nome" type="search" id="nome" placeholder="Nome"></b-form-input>
          </b-col>
          <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
            <label class="sa-label-data">Cognome</label>
            <b-form-input v-model="filtro.cognome" type="search" id="cognome" placeholder="Cognome"></b-form-input>
          </b-col>
          <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
            <label class="sa-label-data">Identificativo</label>
            <b-form-input v-model="filtro.identificativo" type="search" id="identificativo" placeholder="Identificativo"></b-form-input>
          </b-col>
          <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
            <label class="sa-label-data">Username</label>
            <b-form-input v-model="filtro.username" type="search" id="username" placeholder="Username"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="sa-form-btn-filter">
          <b-col class="sa-padding-right text-right">
            <b-button type="submit" variant="info">{{ this.$i18n.t("global.lblFind") }}</b-button>
            <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("global.lblResetFilter") }}</b-button>
          </b-col>
        </b-row>
      </b-form>
    </template>
    <template slot="table-body">
      <configurazione-medico-list-component ref="ConfigurazioneMedicoListComponent" @afterLoadData="onAfterLoadData" @beforeLoadData="onBeforeLoadData"></configurazione-medico-list-component>
    </template>
  </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import ConfigurazioneMedicoListComponent from "../components/ConfigurazioneMedicoListComponent.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
import Vue from "vue";
export default {
  mixins: [UtilityMixin],
  components: { SaPageLayout, ConfigurazioneMedicoListComponent },
  data() {
    return {
      btnNewVisible: false,
      pathResource: "",
      linkedit: "/medici",
      showModalLoading: false,
      listKey: 0,
      filtro: {},
      valutazioniOption: [],
    };
  },
  mounted() {
    let me = this;
    me.impostaPermessi();
    let sessionStorage = window.sessionStorage;
    if (sessionStorage["filtro"]) {
      me.filtro = JSON.parse(sessionStorage["filtro"]);
    }
    me.loadData();
  },
  methods: {
    loadData() {
      let me = this;
      me.showModalLoading = true;
      me.$refs.ConfigurazioneMedicoListComponent.loadData();
    },
    onRefresh() {
      let me = this;
      me.loadData();
    },
    onAfterLoadData() {
      let me = this;
      me.showModalLoading = false;
    },
    onBeforeLoadData() {
      let me = this;
      me.showModalLoading = true;
    },
    onSubmit() {
      let me = this;
      let sessionStorage = window.sessionStorage;
      sessionStorage["filtro"] = JSON.stringify(me.filtro);
      me.loadData();
    },
    onReset() {
      let me = this;
      me.filtro = {};
      let sessionStorage = window.sessionStorage;
      sessionStorage["filtro"] = JSON.stringify(me.filtro);
      me.loadData();
    },
    impostaPermessi() {
      let me = this;
      me.btnNewVisible = UtilityMixin.methods.verificaPermessi(Vue.prototype.user, "giubileo", 2);
    },
  },
};
</script>

<style></style>
